<template>
  <div>
    <h5 class="action-right"
      v-for="(lrDetail,index) in getLrNumberDetails"
      :key="index"
      :class="{'is-select': false}"
    >
      <label>{{$t('INDENT_CONSIGNMENT_NUMBER')}}</label>
      <div>
        <div class="form-value">
          <span v-if="getConsignmentNumberForLr(lrDetail)">{{getConsignmentNumberForLr(lrDetail)}}</span>
          <span v-else-if="hideConsignmentEdit">-</span>
          <span v-else>-</span>
        </div>
      </div>
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LrNumberListShipperMixin from '@/modules-v2/indent/mixins/document/LrNumberListShipperMixin';

export default {
  mixins: [LrNumberListShipperMixin],
  data() {
    return {
      enteredConsgtNumber: null,
      showActions: false,
      isLoading: false,
    };
  },
  props: [
    'consgtNumberDetailsForConsignee',
    'destination',
    'isSelectedConsignee',
    'hideConsignmentEdit',
    'legalEntityDetails',
    'isMultiDropGateConfig',
  ],
  computed: {
    ...mapGetters({
      orderDetails: 'order/find',
    }),
    canShowEditView() {
      return this.showActions && this.isSelectedConsignee && !this.hideConsignmentEdit;
    },
    getLrNumberDetails() {
      return this.getLrNumberList(this.destination);
    },
    getConsignmentNumberForLr() {
      return (lrDetails) => {
        if (lrDetails.legal_entity) {
          // re factor
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].legal_entity : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.legal_entity.title === consignmentDetails.tracking_data[0].legal_entity :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        } else if (lrDetails.division_id) {
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].division : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.division_id === consignmentDetails.tracking_data[0].division :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        } else if (lrDetails.source_gate_id) {
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].source_gate_id : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.source_gate_id === consignmentDetails.tracking_data[0].source_gate_id :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        }

        if (this.isMultiDropGateConfig) {
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].consignee_id : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.consignee_id === consignmentDetails.tracking_data[0].consignee_id :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        }

        if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
          (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
            consignmentDetails.tracking_data[0].location_id : false))) {
          const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              lrDetails.location_id === consignmentDetails.tracking_data[0].location_id :
              false));
          return consignment ? consignment.tracking_data[0].booking_id : false;
        }

        return false;
      };
    },
  },
  methods: {
    async saveConsignmentNumber() {
      try {
        this.isLoading = true;
        if (this.enteredConsgtNumber) {
          const orderId = this.orderDetails.order_number;
          const transporterName = this.orderDetails && this.orderDetails.transporter && this.orderDetails.transporter.name;
          const consigneeId = this.destination.location_id;
          const data = {
            consignment_number: this.enteredConsgtNumber,
          };
          setInterval(() => {
            if (this.isLoading) {
              this.$warningMessage({ message: this.$getConst('COURIER_WARNING', { firstArgument: transporterName }) });
            }
          }, 10000);
          const result = await this.$store.dispatch('order/saveConsignmentNumber', {
            orderId,
            consigneeId,
            data,
          });
          if (!result) {
            this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_FAILURE') });
          } else if (result.error) {
            if (result.error === this.$getErr('CONSIGNMENT_NOT_FOUND')) {
              this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_INVALID') });
            } else {
              this.$error({ message: await this.$getErr('TIMEOUT', { firstArgument: transporterName }) });
            }
          } else {
            this.isConsignmentEdit = false;
            await this.$emit('loadConsignmentDetails');
            this.$success({ message: this.$getSuccess('CONSIGNMENT_UPDATE_SUCCESS') });
          }
          this.closeEditView();
        } else {
          this.$error({ message: 'Please change the consignment number to save!' });
        }
      } catch (error) {
        this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_FAILURE') });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
